import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 font-bold rounded bg-blue-500 text-gray-100 hocus:bg-gray-100 hocus:text-blue-500 focus:shadow-outline hocus:shadow-outline focus:outline-none hocus:outline-none transition duration-300 `;
